import DZModelPage from "@/model/DZModelPage";

class DZSearchHomestay extends DZModelPage{

    /**
     * 租赁方式
     */
    leasingMethod = "";

    /**
     * 住宿容纳
     */
    accommodate = "";

    /**
     * 最小面积
     */
    areaFrom = "";

    /**
     * 最大面积
     */
    areaTo = "";

    /**
     * 关键字
     */
    key = "";

    /**
     * 类型
     */
    status;

    county = "";

    countyArr = [];

    level = "";
}
export default DZSearchHomestay
